import z from "zod";

import { apiRequest } from "./apiUtils";

export const WorkerSummarySchema = z.object({
  user_id: z.string(),
  full_name: z.string().nullable().optional(),
  avatar_url: z.string().nullable().optional(),
  preferred_role: z.string().nullable().optional(),
  last_shift_date: z.string().nullable().optional(),
  starred_at: z.string().nullable().optional(),
  overall_rating: z.number().nullable().optional(),
  rating_count: z.number().nullable().optional(),
});

export type WorkerSummary = z.infer<typeof WorkerSummarySchema>;

const StarredWorkerListSchema = z.object({
  success: z.boolean().default(true),
  message: z.string().nullable().optional(),
  workers: z.array(WorkerSummarySchema).default([]),
});

const StarredWorkerStatusSchema = z.object({
  success: z.boolean().default(true),
  message: z.string().nullable().optional(),
  starred: z.boolean(),
});

export async function listStarredWorkers(): Promise<Array<WorkerSummary>> {
  const data = await apiRequest<unknown>("business/starred-worker", {
    method: "GET",
  });
  return StarredWorkerListSchema.parse(data).workers;
}

export async function getStarredStatus(workerId: string): Promise<boolean> {
  const data = await apiRequest<unknown>(
    `business/starred-worker/${encodeURIComponent(workerId)}`,
    { method: "GET" },
  );
  return StarredWorkerStatusSchema.parse(data).starred;
}

export async function starWorker(workerId: string): Promise<boolean> {
  const data = await apiRequest<unknown>(
    `business/starred-worker/${encodeURIComponent(workerId)}`,
    { method: "POST" },
  );
  return StarredWorkerStatusSchema.parse(data).starred;
}

export async function unstarWorker(workerId: string): Promise<boolean> {
  const data = await apiRequest<unknown>(
    `business/starred-worker/${encodeURIComponent(workerId)}`,
    { method: "DELETE" },
  );
  return StarredWorkerStatusSchema.parse(data).starred;
}
